import events from './events'
import validate from './validate'

export default {
  events: events,
  validateEvents: validate,
}
